/**
 * @generated SignedSource<<d1f58fe9c0cb9e87b4be05a227105c53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type usersSagasSaveUserMobileWalletCredentialsCountQuery$variables = {
  customerId: string;
};
export type usersSagasSaveUserMobileWalletCredentialsCountQuery$data = {
  readonly customer: {
    readonly mobileWalletCredentialPoolLevel?: number;
    readonly mobileWalletCredentialsSummary?: {
      readonly activeDigitalCardCount: number;
    } | null;
  } | null;
};
export type usersSagasSaveUserMobileWalletCredentialsCountQuery = {
  response: usersSagasSaveUserMobileWalletCredentialsCountQuery$data;
  variables: usersSagasSaveUserMobileWalletCredentialsCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "customerId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileWalletCredentialPoolLevel",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeDigitalCardCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usersSagasSaveUserMobileWalletCredentialsCountQuery",
    "selections": [
      {
        "alias": "customer",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WalletCredentialSummary",
                "kind": "LinkedField",
                "name": "mobileWalletCredentialsSummary",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Customer",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usersSagasSaveUserMobileWalletCredentialsCountQuery",
    "selections": [
      {
        "alias": "customer",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WalletCredentialSummary",
                "kind": "LinkedField",
                "name": "mobileWalletCredentialsSummary",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Customer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f0097109dbf9e2a2bb2888d3df9406ce",
    "id": null,
    "metadata": {},
    "name": "usersSagasSaveUserMobileWalletCredentialsCountQuery",
    "operationKind": "query",
    "text": "query usersSagasSaveUserMobileWalletCredentialsCountQuery(\n  $customerId: ID!\n) {\n  customer: node(id: $customerId) {\n    __typename\n    ... on Customer {\n      mobileWalletCredentialPoolLevel\n      mobileWalletCredentialsSummary {\n        activeDigitalCardCount\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "498392b83419a86072ea1fba4bb35bc1";

export default node;
